import { RouteGuards } from '../route-guards/route-guards';
import { USER_ROLE_PERMISSIONS_FOR_GUARDS } from '../route-guards/user-role-permissions-for-route-guards.constant';
import { ShelterNetworkSettingsComponent } from '../../shelter/shelter-network-settings/shelter-network-settings.component';

export const shelterNetworkSettingsRoute = {
  path: 'network/shelter/settings/user-permissions',
  url: '/network/shelter/settings/user-permissions',
  rolePermissions: USER_ROLE_PERMISSIONS_FOR_GUARDS['network/shelter/settings'],
  authenticationRequired: true,
  canActivate: [RouteGuards],
  component: ShelterNetworkSettingsComponent,
};
